var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: `${_vm.form.id ? "编辑" : "发布"}${_vm.title}`,
        width: 700,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            labelCol: { span: 2 },
            wrapperCol: { span: 22 },
            model: _vm.form,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "标题", prop: "title" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入测评标题" },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "测评", prop: "evaluationId" } },
            [
              _c("a-select", {
                attrs: { options: _vm.evalOptions, placeholder: "请选择测评" },
                model: {
                  value: _vm.form.evaluationId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "evaluationId", $$v)
                  },
                  expression: "form.evaluationId",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            {
              staticClass: "cover-item",
              attrs: { label: "封面", prop: "cover" },
            },
            [
              _c("j-image-upload", {
                ref: "coverRef",
                attrs: { accept: ".png,.jpg,.jpeg", bizPath: "dayOath" },
                model: {
                  value: _vm.form.coverUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "coverUrl", $$v)
                  },
                  expression: "form.coverUrl",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }